/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { getCookie } from 'cookies-next';

/**
 * Helper dùng chung cho CẢ HAI interceptor (web + webinapp).
 * Chỉ chứa logic thuần (URL host matching + cookie probe) — KHÔNG chứa flow
 * auth/refresh/logout để 2 nhánh xử lý hoàn toàn tách biệt.
 */

/**
 * Có cookie `refresh_token` hay không. Đây là tín hiệu PHÂN LOẠI session CHUẨN
 * NHẤT: CHỈ web login (OAuth callback → setAuthCookies) mới set refresh_token;
 * webinapp (login bằng token URL) KHÔNG bao giờ có. Cookies không HttpOnly nên
 * đọc được client-side. Dùng để route interceptor (có refresh_token ⟹ chắc chắn web).
 */
export function hasRefreshToken(): boolean {
  try {
    return Boolean(getCookie('refresh_token'));
  } catch {
    return false;
  }
}

const AHAFOOD_API_HOST = (() => {
  try {
    return new URL(
      process.env.NEXT_PUBLIC_API_URI || 'https://apistg.ahamove.com'
    ).host;
  } catch {
    return '';
  }
})();

/**
 * Check if request URL targets AhaFood BE host. Skip Bearer attach cho
 * cross-origin URL (CMS strapi, dplaces, google geocode...) vì các BE đó
 * không expect Ahamove JWT → trả 401.
 */
export function shouldAttachBearer(url: string | undefined): boolean {
  if (!url) return true;
  // Relative URL → assume API_URI baseURL → attach
  if (url.startsWith('/') || !/^https?:\/\//.test(url)) return true;
  // Absolute URL → only attach nếu match AhaFood host
  try {
    return new URL(url).host === AHAFOOD_API_HOST;
  } catch {
    return false;
  }
}
